import React from 'react';
import strings from 'strings';
import * as styles from './ReadyForEtrnBanner.scss';

import { Banner } from '../Banner';

const ReadyForEtrnBanner = (props) => {
  const {
    readyForEtrnUrl,
    closeBanner,
    imageUrl,
  } = props;

  return (
    <Banner
      url={readyForEtrnUrl}
      closeBanner={closeBanner}
      primaryText={strings.getBadgeEtrn}
      secondaryText={strings.standOutFromCompetition}
      buttonText={strings.getBadge}
      imageUrl={imageUrl}
      imageAlt="etrn-image"
      className={styles.readyForEtrnBanner}
    />
  );
};

export default ReadyForEtrnBanner;
